import { render, staticRenderFns } from "./UserHistoryView.vue?vue&type=template&id=4a63e0bf&scoped=true&"
import script from "./UserHistoryView.vue?vue&type=script&lang=js&"
export * from "./UserHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63e0bf",
  null
  
)

export default component.exports